// extracted by mini-css-extract-plugin
export default {"actions":"Facturas_actions__5YGI9","download":"Facturas_download__QYUUo","mes":"Facturas_mes__ZhYH8"};